export default __webpack_public_path__ + "static/media/Feature2(1).32c55023.png";